export enum FeedbackType {
  Bug = 1,
  Feature = 2,
  Improvement = 3,
  Other = 4
}

export enum FeedbackStatus {
  New = 1,
  InProgress = 2,
  Resolved = 3,
  Declined = 4
}

export interface FeedbackAttachment {
  id: string;
  feedbackId?: string;
  fileName: string;
  fileSizeBytes: number;
  isRevitFile: boolean;
  uploadedAt: string | Date;
  contentType: string;
  blobUrl?: string;
  blobPath?: string;
}

export interface FeedbackItem {
  id: string;
  userId: string;
  userEmail: string;
  userName: string;
  type: FeedbackType;
  status: FeedbackStatus;
  title: string;
  description: string;
  revitVersion: string;
  pluginVersion: string;
  osVersion: string;
  sessionId?: string | null;
  createdAt: string | Date;
  updatedAt?: string | Date | null;
  resolvedAt?: string | Date | null;
  attachments: FeedbackAttachment[];
}

export interface FeedbackListDto {
  id: string;
  userId: string;
  userEmail: string;
  userName: string;
  type: FeedbackType;
  status: FeedbackStatus;
  title: string;
  revitVersion: string;
  pluginVersion: string;
  osVersion: string;
  sessionId?: string | null;
  createdAt: string | Date;
  updatedAt?: string | Date | null;
  resolvedAt?: string | Date | null;
  attachmentCount?: number;
  attachmentsCount?: number;
  totalAttachmentsSizeBytes?: number;
}

export interface PagedFeedbackResult<T = FeedbackListDto> {
  items: T[];
  totalCount: number;
  page?: number;
  pageNumber?: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface FeedbackFilterParams {
  status?: FeedbackStatus | 'all';
  type?: FeedbackType | 'all';
  search?: string;
  fromDate?: string;
  toDate?: string;
  startDate?: string;
  endDate?: string;
  pageNumber?: number;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDescending?: boolean;
  revitVersion?: string;
  pluginVersion?: string;
  userId?: string;
}

export interface UpdateFeedbackStatusRequest {
  status: FeedbackStatus;
}
